import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
} from '@app/shared';
import { OpcionesEspeciales } from '../../view-form/view-form.component';


@Injectable()
export class SpecialOptionsFormsService {
  constructor() { }

  /**
   * Genera el formulario de opciones especiales de la forma
   *
   * @param {*} parameters
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof SpecialOptionsFormsService
   */
  getFormSpecialOptions(data?: OpcionesEspeciales): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'chkDefinirOrdenPestanas',
        type: 'checkbox',
        label: 'Definir orden de pestañas',
        value: data ?
                data.orden_pestanas ?
                  data.orden_pestanas.length ?
                    true :
                  false :
                false :
              false,
        order: 1,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formulario para la columna orden en la tabla de Definir orden de pestañas
   *
   * @param {number} max
   * @returns
   * @memberof SpecialOptionsFormsService
   */
  getTabOrderForm(max: number) {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'orden',
        type: 'number',
        label: 'Orden de pestaña:',
        placeholder: 'Orden de pestaña:',
        value: null,
        order: 1,
        validations: {
          validators: [Validators.max(max), Validators.min(1), Validators.required],
          messages: {
            min: 'El orden debe ser mayor a 0.',
            max: 'El orden debe ser menor o igual a ' + max + '.',
            required: 'Campo requerido.'
          }
        },
        class: {
          label: ['d-none'],
          input: []
        },
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formulario para la columna requerido en la tabla de Definir orden de pestañas
   *
   * @returns
   * @memberof SpecialOptionsFormsService
   */
  getRequiredTabForm() {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'requerido',
        type: 'checkbox',
        label: 'Requerido',
        value: null,
        order: 1,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formulario para la columna orden en la tabla de Definir orden de pestañas
   *
   * @param {number} max
   * @returns
   * @memberof SpecialOptionsFormsService
   */
  getTabNameForm() {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        type: 'text',
        label: 'Nombre de la pestaña:',
        placeholder: 'Nombre de la pestaña:',
        value: null,
        order: 1,
        validations: {
          validators: [Validators.required],
          messages: {required: 'Campo requerido.'}
        },
        class: {
          label: ['d-none'],
          input: []
        },
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/special-options/shared/special-options.form.service.ts